/*
 * File: locale.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:43 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: April 1, 2025 at 1:59 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Constants
import { AVAILABLE_LOCALES } from '../../constants/base.constants';


/**
 * Utilities
 */

export const createLocaleVariants = (route) => {

	// Get parameters
	const { path, paths } = route;
	const routes = path ? [route] : paths.map((pathObj) => ({
		...route,
		path: pathObj
	}));

	// Create route for each locale
	if (path) {
		AVAILABLE_LOCALES.forEach((locale) => {
			routes.push({
				...route,
				path: `/${locale}${path}`,
				localeId: locale,
				isAlternative: true
			});
		});
	} else if (paths) {
		paths.forEach((pathObj) => {
			AVAILABLE_LOCALES.forEach((locale) => {
				routes.push({
					...route,
					path: `/${locale}${pathObj}`,
					localeId: locale,
					isAlternative: true
				});
			});
		});
	}

	// Return routes
	return routes;
};

export const isLinkActive = (location, to, locale, isExplicit = true) => (isExplicit ? location.pathname === to || location.pathname === `${locale.localePath}${to}` : location.pathname.startsWith(to) || location.pathname.startsWith(`${locale.localePath}${to}`));
